import type { UntitledIconData } from '../../UntitledIconData'

export const ulSearchMd: UntitledIconData = {
  prefix: 'ul',
  name: 'search-md',
  paths: [
    {
      shape:
        'M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z',
    },
  ],
}
